import { UAM_URL } from './externalLinks';

const normalizeEntryUrl = (value) => String(value || '').trim();

export function isAbsoluteHttpUrl(value) {
  return /^https?:\/\//i.test(normalizeEntryUrl(value));
}

export function isMarkbaseZoneUrl(value) {
  const raw = normalizeEntryUrl(value);
  if (!isAbsoluteHttpUrl(raw)) return false;
  try {
    const hostname = new URL(raw).hostname.toLowerCase();
    return hostname === 'markbase.ru' || hostname.endsWith('.markbase.ru');
  } catch (_) {
    return false;
  }
}

export function buildExternalModuleEntryUrl(targetUrl, { promptAccount = false } = {}) {
  const raw = normalizeEntryUrl(targetUrl);
  if (!isAbsoluteHttpUrl(raw)) return raw;
  if (isMarkbaseZoneUrl(raw)) return raw;

  const params = new URLSearchParams();
  params.set('return_url', raw);
  if (promptAccount) params.set('prompt', 'login');
  return `${UAM_URL}/login?${params.toString()}`;
}

export function openExternalModuleEntry(targetUrl, options = {}) {
  const entryUrl = buildExternalModuleEntryUrl(targetUrl, options);
  if (!entryUrl || typeof window === 'undefined') return null;
  return window.open(entryUrl, '_blank', 'noopener,noreferrer');
}
